function a(a, n) {
  return null == n && (n = a, a = 0), a + Math.floor(Math.random() * (n - a + 1));
}
export { a as default };